// import { useEffect, useState } from "react";
// import PavilionTable from "./PavilionTable";
// import PavilionForm from "./PavilionForm";
// import Modal from "components/common/Modal";
// import { usePavilions } from "./hooks/usePavilions";
// import { useOrganizers } from "components/company/hooks/useOrganizers";
// import Alert from "components/common/Alert";

// export default function PavilionContainer() {
//   const {
//     data,
//     loading,
//     loadPavilions,
//     loadPavilionById,
//     addPavilion,
//     editPavilion,
//     deletePavilion,
//   } = usePavilions();

//   const [openAdd, setOpenAdd] = useState(false);
//   const [editing, setEditing] = useState(null);
//   const [editLoading, setEditLoading] = useState(false);
//   const [alert, setAlert] = useState({ type: "", message: "" });

//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   const userId = localStorage.getItem("user_id") || "69579c6190a653b640e65639";

//   useEffect(() => {
//     if (selectedOrganizer) {
//       loadPavilions(selectedOrganizer);
//     }
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     const handleOrganizerChange = (e) => {
//       setSelectedOrganizer(e.detail);
//     };
//     window.addEventListener("companyChanged", handleOrganizerChange);
//     return () =>
//       window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);

//   return (
//     <>
//       <div className="mb-4 flex justify-end">
//         <button
//           className="rounded bg-blue-600 px-4 py-2 text-white"
//           onClick={() => setOpenAdd(true)}
//         >
//           + Add Pavilion
//         </button>
//       </div>

//       {alert.message && (
//         <Alert
//           type={alert.type}
//           message={alert.message}
//           onClose={() => setAlert({ type: "", message: "" })}
//           autoClose
//         />
//       )}

//       <PavilionTable
//         data={data}
//         loading={loading}
//         onEdit={setEditing}
//         onDelete={async (row) => {
//           try {
//             const res = await deletePavilion(row._id, {
//               is_deleted: true,
//               deleted_by: userId,
//             });
//             setAlert({
//               type: "success",
//               message: "Pavilion deleted successfully",
//             });
//             loadPavilions(selectedOrganizer);
//           } catch (error) {
//             setAlert({
//               type: "error",
//               message: error.response?.data?.message || "Something went wrong while deleting pavilion",
//             });
//           }
//         }}
//       />

//       <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
//         <PavilionForm
//           onClose={() => setOpenAdd(false)}
//           onSubmit={async (payload) => {
//             try {
//               await addPavilion({
//                 ...payload,
//                 created_by: userId,
//                 updated_by: userId,
//               });
//               setAlert({
//                 type: "success",
//                 message: "Pavilion created successfully",
//               });
//               setOpenAdd(false);
//               loadPavilions(selectedOrganizer);
//             } catch (error) {
//               setAlert({
//                 type: "error",
//                 message: error.response?.data?.message || "Something went wrong while creating pavilion",
//               });
//             }
//           }}
//         />
//       </Modal>

//       <Modal open={!!editing} onClose={() => setEditing(null)}>
//         {editLoading ? (
//           <p className="p-4 text-center">Loading...</p>
//         ) : (
//           <PavilionForm
//             initialData={editing}
//             onClose={() => setEditing(null)}
//             onSubmit={async (payload) => {
//               try {
//                 await editPavilion(editing._id, {
//                   ...payload,
//                   updated_by: userId,
//                 });
//                 setAlert({
//                   type: "success",
//                   message: "Pavilion updated successfully",
//                 });
//                 setEditing(null);
//                 loadPavilions(selectedOrganizer);
//               } catch (error) {
//                 setAlert({
//                   type: "error",
//                   message: error.response?.data?.message || "Something went wrong while updating pavilion",
//                 });
//               }
//             }}
//           />
//         )}
//       </Modal>
//     </>
//   );
// }

import { useEffect, useState, useCallback } from "react";
import { MdSearch, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import PavilionTable from "./PavilionTable";
import PavilionForm from "./PavilionForm";
import Modal from "components/common/Modal";
import { usePavilions } from "./hooks/usePavilions";
import Alert from "components/common/Alert";
import CustomButton from "components/CustomButton";
import { InputField } from "components/FormFields";

export default function PavilionContainer() {
  const {
    data,
    loading,
    paginationInfo,
    loadPavilions,
    addPavilion,
    editPavilion,
    deletePavilion,
  } = usePavilions();

  const [openAdd, setOpenAdd] = useState(false);
  const [editing, setEditing] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  const userId = localStorage.getItem("user_id") || "69579c6190a653b640e65639";

  // Debounce Search Input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  const fetchData = useCallback(() => {
    if (selectedOrganizer) {
      loadPavilions(selectedOrganizer, {
        page,
        limit,
        search: debouncedSearch,
      });
    }
  }, [selectedOrganizer, page, limit, debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };
    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  const handleDeletePavilion = async (id) => {
    try {
      await deletePavilion(id, {
        is_deleted: true,
        deleted_by: userId,
      });
      setAlert({
        type: "success",
        message: "Pavilion deleted successfully",
      });
      fetchData();
    } catch (error) {
      setAlert({
        type: "error",
        message:
          error.response?.data?.message ||
          "Something went wrong while deleting pavilion",
      });
    }
  };

  return (
    <TablePageLayout>
      <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col">
          <InputField
            label="SEARCH"
            name="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search pavilion..."
            icon={<MdSearch className="text-lg text-gray-400" />}
          />
        </div>

        <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
          <CustomButton
            label="Add Pavilion"
            icon={MdAddBox}
            iconPos="right"
            variant="solid"
            color="#02a9e0"
            onClick={() => setOpenAdd(true)}
          />
        </div>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          autoClose
        />
      )}

      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading pavilions...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <PavilionTable
            data={data}
            onEdit={setEditing}
            onDelete={handleDeletePavilion}
          />

          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalPavilions}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}

      {/* Add Pavilion Modal */}
      <Modal open={openAdd} onClose={() => setOpenAdd(false)} title={"Create Pavilion"}>
        <PavilionForm
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload) => {
            try {
              await addPavilion({
                ...payload,
                created_by: userId,
                updated_by: userId,
              });
              setAlert({
                type: "success",
                message: "Pavilion created successfully",
              });
              setOpenAdd(false);
              fetchData();
            } catch (error) {
              setAlert({
                type: "error",
                message:
                  error.response?.data?.message ||
                  "Something went wrong while creating pavilion",
              });
            }
          }}
        />
      </Modal>

      {/* Edit Pavilion Modal */}
      <Modal open={!!editing} onClose={() => setEditing(null)} title={"Edit Pavilion"}>
        {editLoading ? (
          <p className="p-4 text-center">Loading...</p>
        ) : (
          <PavilionForm
            initialData={editing}
            onClose={() => setEditing(null)}
            onSubmit={async (payload) => {
              try {
                await editPavilion(editing._id, {
                  ...payload,
                  updated_by: userId,
                });
                setAlert({
                  type: "success",
                  message: "Pavilion updated successfully",
                });
                setEditing(null);
                fetchData();
              } catch (error) {
                setAlert({
                  type: "error",
                  message:
                    error.response?.data?.message ||
                    "Something went wrong while updating pavilion",
                });
              }
            }}
          />
        )}
      </Modal>
    </TablePageLayout>
  );
}